<section class="ndf-operation-list">
  <div class="ndf-operation-list__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="ndf-operation-list__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="ndf-operation-list__header">
    <div class="ndf-operation-list__header__title">
      <h1 class="mb-0 mb-md-2">
        {{ tk.Management.NdfDerivativesManagement | t }}
      </h1>
    </div>
  </div>
  <div class="ndf-operation-list__header__search px-3">
    <div class="form-search me-3 d-none d-md-flex mb-2">
      <app-select-company
        [multiple]="true"
        [selectionScope]="'page-filter'"
        [persistLocalSelectionToUrl]="true"
        [selectedCompanyValues]="selectedCompanyIds"
        (sendSelectedOptionMultiple)="handleOptionChange($event, 'selectedCompany')">
      </app-select-company>
    </div>
  </div>
  <div class="ndf-operation-list__content mt-3">
    <app-tab-view
      [tabIndex]="tabViewActiveIndex"
      [tabViewItems]="tabViewItems"
      (sendTabViewActiveIndex)="handleTabView($event)">
    </app-tab-view>

    <div class="d-flex justify-content-between">
      <div class="w-25">
        <app-search
          [isLoading]="isLoading"
          [value]="search"
          [placeholder]="(tk.General.Search | t) || ''"
          (sendSearch)="handleSearch($event)">
        </app-search>
      </div>
      <div class="d-flex align-items-center">
        <!-- Toggle de visualização -->
        <div class="btn-group me-3">
          <app-button
            [id]="'view-cards'"
            [icon]="'pi pi-th-large'"
            [theme]="'white'"
            [selected]="viewMode === 'cards'"
            [label]="'Cards'"
            [class]="'me-2'"
            (sendButtonClick)="setViewMode('cards')">
          </app-button>
          <app-button
            [id]="'view-table'"
            [icon]="'pi pi-table'"
            [theme]="'white'"
            [selected]="viewMode === 'table'"
            [label]="'Tabela'"
            (sendButtonClick)="setViewMode('table')">
          </app-button>
        </div>
        <app-button
          [id]="'filter-all'"
          [icon]="'pi pi-filter'"
          [theme]="'white'"
          [label]="tk.General.Filter | t"
          (sendButtonClick)="handleFilterActive(true)">
        </app-button>
      </div>
    </div>
    <!-- Filtros Ativos -->
    <app-active-filters
      [filterConfigs]="activeFilterConfigs"
      [ignoredProperties]="['filter']"
      [showClearButton]="true"
      [clearButtonLabel]="(tk.General.Clear | t) || 'Limpar'"
      (filterRemoved)="onRemoveFilter($event)"
      (allFiltersCleared)="onClearAllFilters()">
    </app-active-filters>

    <!-- Enquanto a primeira resposta não chega, esqueleto; antes caía no "Sem operações cadastradas". -->
    <app-table-skeleton
      *ngIf="!operationsLoaded"
      [rowCount]="10"
      [columnWidths]="[
        100, 150, 150, 120, 175, 120, 150, 100, 150, 120, 120, 120, 149, 140, 174, 120, 151, 127,
      ]"
      [groupHeader]="true"
      [showToolbar]="true" />
    <ng-container *ngIf="operationsLoaded && ndfOperations.length; else templateNoOperations">
      <!-- Visualização em Cards -->
      <ng-container *ngIf="viewMode === 'cards'">
        <ng-container *ngFor="let operation of ndfOperations; let iOperation = index">
          <ng-container *ngIf="!tabViewActiveIndex; else templateFilteredOperation">
            <app-ndf-operation-card-summary
              [ptaxQuotesDates]="ptaxQuotesDates"
              [operation]="operation"
              [isMobile]="isMobile"
              [isQuotable]="false"
              [isHirable]="false"
              [isSalable]="
                operation.operationStatus === operationStatus.Hired &&
                operation.financialStatus === 'Open'
              "
              [isLiquidatable]="
                operation.operationStatus === 'Hired' && operation.settlementDate !== null
              "
              [currencyOptions]="currencyOptions"
              (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)">
            </app-ndf-operation-card-summary>
          </ng-container>

          <ng-template #templateFilteredOperation>
            <ng-container [ngSwitch]="operation.operationStatus">
              <ng-container *ngSwitchCase="operationStatus.Simulated">
                <ng-container *ngIf="tabViewActiveIndex === 1">
                  <app-ndf-operation-card-summary
                    [ptaxQuotesDates]="ptaxQuotesDates"
                    [operation]="operation"
                    [isMobile]="isMobile"
                    [isQuotable]="false"
                    [isHirable]="false"
                    [isSalable]="false"
                    [currencyOptions]="currencyOptions"
                    (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)">
                  </app-ndf-operation-card-summary>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="operationStatus.Quoted">
                <ng-container *ngIf="tabViewActiveIndex === 2">
                  <app-ndf-operation-card-summary
                    [ptaxQuotesDates]="ptaxQuotesDates"
                    [operation]="operation"
                    [isMobile]="isMobile"
                    [isHirable]="false"
                    [isSalable]="false"
                    [currencyOptions]="currencyOptions"
                    (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)">
                  </app-ndf-operation-card-summary>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="operationStatus.Hired">
                <ng-container *ngIf="tabViewActiveIndex === 3">
                  <app-ndf-operation-card-summary
                    [ptaxQuotesDates]="ptaxQuotesDates"
                    [operation]="operation"
                    [isMobile]="isMobile"
                    [isHirable]="false"
                    [isLiquidatable]="true"
                    [isSalable]="
                      operation.operationStatus === operationStatus.Hired &&
                      operation.financialStatus === 'Open'
                    "
                    [currencyOptions]="currencyOptions"
                    (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)">
                  </app-ndf-operation-card-summary>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>

      <!-- Visualização em Tabela -->
      <ng-container *ngIf="viewMode === 'table'">
        <app-table
          [hasFilter]="false"
          [title]="'Derivativos'"
          [subtitle]="'Listagem de Operações'"
          [reorderableColumns]="true"
          [resizableColumns]="true"
          [sortable]="true"
          [hasCheckbox]="false"
          [enableGroupHeaders]="true"
          [totalRecords]="pagination.total"
          [items]="ndfOperations"
          [showSearch]="false"
          [columnDefinitions]="columnDefinitions"
          [rows]="pagination.itemsPerPage || 10"
          [firstRow]="firstRow"
          [getOptionsFunction]="getMenuActions.bind(this)"
          [allowSelectColumns]="true"
          [hasPagination]="false"
          (sendTableAction)="handleTableAction($event)"
          (sendTableSort)="handleTableSort($event)"
          (sendTablePagination)="handleTablePagination($event)">
          <!-- Template customizado para sequentialId -->
          <ng-template appNamedTemplate="sequentialId" let-item>
            <a
              class="text-primary text-decoration-none fw-bold"
              [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
              [queryParams]="{ demandId: item?.derivativeOperationDemandId, operationId: item?.id }"
              style="cursor: pointer">
              {{ item.sequentialId }}
            </a>
          </ng-template>

          <!-- Template customizado para operationStatus -->
          <ng-template appNamedTemplate="operationStatus" let-item>
            {{ getOperationStatusLabel(item.operationStatus) }}
          </ng-template>

          <!-- Template customizado para financialStatus -->
          <ng-template appNamedTemplate="financialStatus" let-item>
            {{ getFinancialStatusLabel(item.financialStatus) }}
          </ng-template>

          <!-- Template customizado para reference -->
          <ng-template appNamedTemplate="reference" let-item>
            <span [title]="item.reference || '-'">
              {{
                item.reference && item.reference.length > 20
                  ? (item.reference | slice: 0 : 20) + '...'
                  : item.reference || '-'
              }}
            </span>
          </ng-template>

          <!-- Template customizado para userName -->
          <ng-template appNamedTemplate="userName" let-item>
            <span [title]="item.userName || '-'">
              {{ item.userName || '-' }}
            </span>
          </ng-template>

          <!-- Template para a coluna de Modalidade -->
          <ng-template appNamedTemplate="operationType" let-item>
            {{ getOperationStrategyTypeLabel(item.operationStrategyType) }}
          </ng-template>

          <ng-template appNamedTemplate="capValue" let-item>
            {{
              item.capValue && item.capValue > 0 ? (item.capValue | vaultFormatCurrency: 4) : '-'
            }}
          </ng-template>

          <!-- Template para Prêmio -->
          <ng-template appNamedTemplate="premium" let-item>
            {{ item.premium && item.premium > 0 ? (item.premium | vaultFormatCurrency: 2) : '-' }}
          </ng-template>

          <!-- Template para Forward Rate -->
          <ng-template appNamedTemplate="forwardRate" let-item>
            {{
              item.forwardRate && item.forwardRate > 0
                ? (item.forwardRate | vaultFormatCurrency: 4)
                : '-'
            }}
          </ng-template>

          <!-- Template para Strike de Compra -->
          <ng-template appNamedTemplate="strikeBuy" let-item>
            {{
              item.strikeBuy && item.strikeBuy > 0 ? (item.strikeBuy | vaultFormatCurrency: 4) : '-'
            }}
          </ng-template>

          <!-- Template para Strike de Venda -->
          <ng-template appNamedTemplate="strikeSell" let-item>
            {{
              item.strikeSell && item.strikeSell > 0
                ? (item.strikeSell | vaultFormatCurrency: 4)
                : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="strikeSell" let-item>
            {{
              item.strikeSell && item.strikeSell > 0
                ? (item.strikeSell | vaultFormatCurrency: 4)
                : '-'
            }}
          </ng-template>

          <!-- Templates para SWAP -->
          <ng-template appNamedTemplate="activeIndexer" let-item>
            {{ item.activeIndexer || '-' }}
          </ng-template>

          <ng-template appNamedTemplate="passiveIndexer" let-item>
            {{ item.passiveIndexer || '-' }}
          </ng-template>

          <ng-template appNamedTemplate="activeFixedRatePerYear" let-item>
            {{
              item.activeFixedRatePerYear && item.activeFixedRatePerYear > 0
                ? (item.activeFixedRatePerYear | vaultFormatCurrency: 2) + '%'
                : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="passiveFixedRatePerYear" let-item>
            {{
              item.passiveFixedRatePerYear && item.passiveFixedRatePerYear > 0
                ? (item.passiveFixedRatePerYear | vaultFormatCurrency: 2) + '%'
                : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="dayCountConvention" let-item>
            {{ item.dayCountConvention || '-' }}
          </ng-template>

          <!-- Templates para Liquidação -->
          <ng-template appNamedTemplate="settlementNotional" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.settlementNotional && item.settlementNotional > 0
                  ? (item.settlementNotional | currency: '' : '' : '1.2-2')
                  : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="settlementRate" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.settlementRate && item.settlementRate > 0
                  ? (item.settlementRate | vaultFormatCurrency: 4)
                  : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="totalAmount" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.totalAmount !== null && item.totalAmount !== undefined
                  ? (item.totalAmount | currency: 'BRL' : 'symbol' : '1.2-2')
                  : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="withholdingTax" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.withholdingTax !== null && item.withholdingTax !== undefined
                  ? (item.withholdingTax | currency: 'BRL' : 'symbol' : '1.2-2')
                  : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="incomeTaxPayable" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.incomeTaxPayable !== null && item.incomeTaxPayable !== undefined
                  ? (item.incomeTaxPayable | currency: 'BRL' : 'symbol' : '1.2-2')
                  : '-'
            }}
          </ng-template>

          <ng-template appNamedTemplate="netAmount" let-item>
            {{
              !item.settlementDate
                ? '-'
                : item.netAmount !== null && item.netAmount !== undefined
                  ? (item.netAmount | currency: 'BRL' : 'symbol' : '1.2-2')
                  : '-'
            }}
          </ng-template>

          <!-- Template para a coluna de Banco -->
          <ng-template appNamedTemplate="bank" let-item>
            <div class="d-flex align-items-center">
              <app-bank-logo
                *ngIf="item.financialInstitution?.compensationCode"
                [code]="item.financialInstitution.compensationCode"
                class="me-2" />
              {{ item.financialInstitution?.displayName }}
            </div>
          </ng-template>

          <!-- Template para a coluna de Valor -->
          <ng-template appNamedTemplate="notionalAmount" let-item>
            <div class="d-flex align-items-center">
              {{ item.demandSummary.currency }}
              {{ item.notionalAmount | currency: '' : '' : '1.2-2' }}
            </div>
          </ng-template>

          <!-- Templates para dados da demanda -->
          <ng-template appNamedTemplate="demandSequentialId" let-item>
            <a
              class="text-primary text-decoration-none fw-bold"
              [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
              [queryParams]="{ demandId: item?.derivativeOperationDemandId }"
              style="cursor: pointer">
              {{ item.demandSummary?.sequentialId || '-' }}
            </a>
          </ng-template>

          <ng-template appNamedTemplate="demandReference" let-item>
            <span [title]="item.demandSummary?.reference || '-'">
              {{
                item.demandSummary?.reference && item.demandSummary.reference.length > 20
                  ? (item.demandSummary.reference | slice: 0 : 20) + '...'
                  : item.demandSummary?.reference || '-'
              }}
            </span>
          </ng-template>

          <ng-template appNamedTemplate="demandCurrency" let-item>
            {{ item.demandSummary?.currency || '-' }}
          </ng-template>

          <ng-template appNamedTemplate="relatedOperations" let-item>
            <div class="d-flex flex-column">
              <ng-container *ngIf="item.demandSummary?.comexOperation?.sequentialId">
                <a
                  class="text-primary text-decoration-none mb-1"
                  (click)="openComexDetailsModal(item.demandSummary.comexOperation.id)"
                  style="cursor: pointer; font-size: 0.875rem">
                  #{{ item.demandSummary.comexOperation.sequentialId }}
                </a>
              </ng-container>
              <ng-container *ngIf="item.demandSummary?.loanOperation?.sequentialId">
                <a
                  class="text-primary text-decoration-none"
                  (click)="openLoanDetailsModal(item.demandSummary.loanOperation.id)"
                  style="cursor: pointer; font-size: 0.875rem">
                  #{{ item.demandSummary.loanOperation.sequentialId }}
                </a>
              </ng-container>
              <ng-container
                *ngIf="
                  !item.demandSummary?.comexOperation?.sequentialId &&
                  !item.demandSummary?.loanOperation?.sequentialId
                ">
                <span style="font-size: 0.875rem">-</span>
              </ng-container>
            </div>
          </ng-template>

          <!-- Template para Parcelas Vinculadas -->
          <ng-template appNamedTemplate="linkedInstallments" let-item>
            <div
              *ngIf="item.installments && item.installments.length > 0; else noInstallments"
              class="installments-cell"
              [pTooltip]="getInstallmentsTooltip(item.installments)"
              [escape]="false"
              appendTo="body"
              tooltipPosition="top"
              [showDelay]="300"
              tooltipStyleClass="installments-tooltip"
              [attr.data-installment-id]="item.id"
              style="font-size: 0.875rem; cursor: help">
              <span *ngIf="item.installments.length === 1">
                {{
                  $any(item.installments[0]).isFlatFee
                    ? 'Flat Fee'
                    : $any(item.installments[0]).installmentNumber
                }}
                | Vencimento: {{ $any(item.installments[0]).dueAt | vaultDate }}
              </span>
              <span *ngIf="item.installments.length > 1">
                {{ item.installments.length }} parcela(s)
              </span>
            </div>
            <ng-template #noInstallments>
              <span style="font-size: 0.875rem">-</span>
            </ng-template>
          </ng-template>

          <!-- Template vazio -->
          <ng-template #emptyTemplate let-items>
            <div class="ndf-operation-list__empty">
              <h4>{{ tk.Management.NdfNoOperationRegistred | t }}</h4>
            </div>
          </ng-template>
        </app-table>
      </ng-container>
    </ng-container>
    <ng-template #templateNoOperations>
      <div *ngIf="operationsLoaded" class="ndf-operation-list__empty">
        <h4>{{ tk.Management.NdfNoOperationRegistred | t }}</h4>
      </div>
    </ng-template>
  </div>
  <div class="ndf-calculator-list__footer" *ngIf="ndfOperations.length">
    <p-paginator
      #paginator
      (onPageChange)="handlePagination($event)"
      [first]="firstRow"
      [rows]="pagination.itemsPerPage || 10"
      [totalRecords]="pagination.total"
      [rowsPerPageOptions]="rowsPerPageOptions" />
  </div>

  <app-ndf-operation-filter
    [isActive]="activeFilter"
    [currencyOptions]="currencyOptions"
    [operationMaxValue]="operationMaxValue"
    [currentFilters]="currentFilters"
    (sendCloseFilter)="handleFilterActive($event)"
    (sendFilter)="handleFilter($event)"
    (sendActiveFilters)="onActiveFiltersChange($event)">
  </app-ndf-operation-filter>
</section>

<app-modal-mtm-daily #mtmDailyModal></app-modal-mtm-daily>

<app-modal-liquidate-operation
  #liquidateOperationModal
  [operationToSaleSummary]="operationToSaleSummary"
  [operationToSale]="operationToSale"
  [operationSaleForm]="operationSaleForm"
  [operationSaleProps]="operationSaleProps"
  [ptaxQuotesDates]="ptaxQuotesDates"
  [isMobile]="isMobile"
  [currencyOptions]="currencyOptions"
  [currentDate]="currentDate"
  [liquidationType]="liquidationType"
  [ptaxQuotationDate]="ptaxQuotationDate"
  (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)"
  (saveReversalRequested)="handleEarlyReversalLiquidation()"
  (calendarValue)="handleCalendarValue($event.value, $event.field)"
  (inputNumber)="handleInputNumber($event.value, $event.field)"
  (liquidateRequested)="onLiquidateOperationRequested()">
</app-modal-liquidate-operation>

<app-dialog
  #hireOperationDialog
  [key]="'hire-operation'"
  [action]="'hire-operation'"
  [headerTheme]="'simple'"
  [title]="(tk.Management.NdfHireQuote | t) || ''"
  (onConfirm)="onHireDialogConfirm()">
  <form *ngIf="operationHireForm" [formGroup]="operationHireForm" appAutoFormGroup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="mb-3">
            <app-calendar
              [label]="(tk.Management.NdfDateAndTime | t) || ''"
              [placeholder]="(tk.General.Insert | t) || ''"
              [showTime]="true"
              [inputId]="'operation-quote'"
              (sendCalendarValue)="handleCalendarValue($event, 'hire')" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <app-input
            [type]="'text'"
            [placeholder]="(tk.General.Insert | t) || ''"
            [controlName]="operationQuoteHireProps.bankOperatorName"
            [label]="tk.Management.NdfFinancialOperator | t"
            [required]="false">
          </app-input>
        </div>
      </div>
    </div>
  </form>

  <app-card-summary *ngIf="derivativeCardInfo" [cardInfo]="derivativeCardInfo" [isCollapsed]="true">
    <app-derivative-summary *ngIf="derivativeSummary" [derivative]="derivativeSummary" />
  </app-card-summary>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <app-button
        [id]="'cancel-hire'"
        [icon]="'pi pi-times'"
        [type]="'button'"
        [theme]="'white'"
        [label]="tk.General.Cancel | t"
        (click)="hireOperationDialogRef?.close()">
      </app-button>
      <app-button
        [id]="'confirm-hire'"
        [icon]="'pi pi-check'"
        [type]="'button'"
        [theme]="'default'"
        [title]="(tk.Management.NdfHireQuote | t) || ''"
        [label]="(tk.Management.NdfHireQuote | t) || ''"
        (click)="onHireDialogConfirm()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>

<app-dialog
  #removeOperationDialog
  [key]="'operation-should-remove'"
  [action]="'operation-should-remove'"
  [icon]="''"
  [title]="(tk.Management.OperationTitleDeleteConfirmation | t) || ''"
  [headerTheme]="'none'">
</app-dialog>

<app-dialog
  #quoteOperationDialog
  [key]="'quote-operation'"
  [action]="'quote-operation'"
  [headerTheme]="'simple'"
  [breakpoints]="{
    '960px': '400px',
    '768px': '70vw',
    '640px': '100vw',
    '480px': '100vw',
  }"
  [title]="(tk.Management.NdfQuote | t) || ''"
  (onConfirm)="onQuoteDialogConfirm()">
  <form *ngIf="operationQuoteForm" [formGroup]="operationQuoteForm" appAutoFormGroup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6">
          <app-calendar
            [label]="(tk.Management.NdfDateAndTime | t) || ''"
            [placeholder]="(tk.General.Insert | t) || ''"
            [showTime]="true"
            [inputId]="'operation-quote'"
            (sendCalendarValue)="handleCalendarValue($event, 'quote')" />
        </div>
        <div class="col-12 col-md-6">
          <app-input
            [type]="'text'"
            [placeholder]="(tk.General.Insert | t) || ''"
            [controlName]="operationQuoteHireProps.bankOperatorName"
            [label]="tk.Management.NdfFinancialOperator | t"
            [required]="false">
          </app-input>
        </div>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <app-button
        [id]="'cancel-quote'"
        [icon]="'pi pi-times'"
        [type]="'button'"
        [theme]="'white'"
        [label]="tk.General.Cancel | t"
        (click)="quoteOperationDialogRef?.close()">
      </app-button>
      <app-button
        [id]="'confirm-quote'"
        [icon]="'pi pi-check'"
        [type]="'button'"
        [theme]="'default'"
        [title]="(tk.Management.NdfQuote | t) || ''"
        [label]="(tk.Management.NdfQuote | t) || ''"
        (click)="onQuoteDialogConfirm()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>

<app-dialog
  #revertLiquidationDialog
  [key]="'revert-liquidation-to-open'"
  [action]="'revert-liquidation-to-open'"
  [headerTheme]="'simple'"
  [title]="(tk.Management.NdfOperationTitleRevertLiquidationConfirmation | t) || ''">
  <app-ndf-operation-card-summary
    [ptaxQuotesDates]="ptaxQuotesDates"
    *ngIf="operationToHireSummary"
    [operation]="operationToHireSummary"
    [isMobile]="isMobile"
    [hasActions]="false"
    [isHirable]="false"
    [currencyOptions]="currencyOptions"
    (sendOperationCardSummaryAction)="handleCardOperationSummaryAction($event)">
  </app-ndf-operation-card-summary>
</app-dialog>

<app-modal-derivative-attachments #attachmentsModal (attachmentUploaded)="onAttachmentUploaded()">
</app-modal-derivative-attachments>

<!-- Modal de Detalhes COMEX -->
<app-modal-comex-operation-details #comexDetailsModal (modalClosed)="onComexDetailsClosed()">
</app-modal-comex-operation-details>

<!-- Modal de Detalhes de Loan -->
<app-modal-loan-details #loanDetailsModal (modalClosed)="onLoanDetailsClosed()">
</app-modal-loan-details>

<app-modal-save-reversal-confirmation
  #saveReversalConfirmationModal
  (confirmSave)="onSaveReversalConfirmed()">
</app-modal-save-reversal-confirmation>

<app-modal-confirm-liquidation
  #confirmLiquidationModal
  (confirmLiquidation)="onSaleDialogConfirm()">
</app-modal-confirm-liquidation>

<app-modal-create-committee #createCommitteeModal></app-modal-create-committee>
